import { createAction, ActionsUnion, DateLike } from 'utils'

export enum TimeActionTypes {
  SET_TIMES = 'SET_TIMES'
}

export const TimeActions = {
  setTimes: (server: DateLike, client: DateLike) => createAction(TimeActionTypes.SET_TIMES, { server, client })
}

export type TimeActions = ActionsUnion<typeof TimeActions>
